import { useCallback } from 'react';
import { useAuth } from '@/context/auth-context';

export function hasMatchingPermission(code: string, permissions: string[]): boolean {
  return permissions.some((p) => p === code || p.startsWith(`${code}:`));
}

export function usePermissions() {
  const { user } = useAuth();

  const hasPermission = useCallback(
    (permission: string): boolean => {
      return user?.permissions?.includes(permission) ?? false;
    },
    [user?.permissions],
  );

  const hasAnyPermission = useCallback(
    (permissions: string[]): boolean => {
      return permissions.some((p) => user?.permissions?.includes(p));
    },
    [user?.permissions],
  );

  const hasAllPermissions = useCallback(
    (permissions: string[]): boolean => {
      return permissions.every((p) => user?.permissions?.includes(p));
    },
    [user?.permissions],
  );

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    permissions: user?.permissions ?? [],
  };
}
